import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const LanguageDropdown = ({showLabel}) => {
	const { t, i18n } = useTranslation();

	const [currentLang, setCurrentLang] = useState(
    Object.keys(i18n.options.resources).includes(i18n.language)
      ? i18n.language
      : "en"
	);
	
	useEffect(() => {
    const currLang = Object.keys(i18n.options.resources).filter(lang => {
      return i18n.language === lang;
    })[0];
    setCurrentLang(currLang);
    // eslint-disable-next-line
	}, [i18n.language]);
	
  const changeLanguageEventListener = e => {
    if (i18n.language === e.currentTarget.value) return;
    i18n.changeLanguage(e.currentTarget.value);
  };
  return (
    <div className="language">
				{showLabel && <span>{t("header.loginMenu.changeLang")}</span>}
        <select
					placeholder={t("header.loginMenu.changeLang")}
					onChange={changeLanguageEventListener}
					defaultValue={currentLang}
					className={"select-lang"}
					>
                    <option value="en">English</option>
					<option value="de">Deutsch</option>
					<option value="ru">Русский</option>
          <option value="mk">Македонски</option>
          <option value="ms">Makedonski</option>
          <option value="sq">Shqip</option>
        </select>
    </div>
  );
};

export default LanguageDropdown;
